/**
 * Values injected at runtime by server.js into `window.__RUNTIME_CONFIG__`
 * (see server.js's injectRuntimeConfig), so one built image can be
 * reconfigured via container env vars without a rebuild. Falls back to the
 * build-time value (webpack Dotenv) when running `webpack serve` locally, or
 * when running outside a browser (e.g. tests).
 */
declare global {
  interface Window {
    __RUNTIME_CONFIG__?: {
      ADDON_ENV?: string;
      LIBRECHAT_AGENT_ID?: string;
      LIBRECHAT_API_URL?: string;
      APP_NAME?: string;
      ENTRA_CLIENT_ID?: string;
      ENTRA_TENANT_ID?: string;
      ENTRA_API_SCOPE?: string;
    };
  }
}

export function getRuntimeConfig(): {
  ADDON_ENV?: string;
  LIBRECHAT_AGENT_ID?: string;
  LIBRECHAT_API_URL?: string;
  APP_NAME?: string;
  ENTRA_CLIENT_ID?: string;
  ENTRA_TENANT_ID?: string;
  ENTRA_API_SCOPE?: string;
} {
  return typeof window !== "undefined" ? (window.__RUNTIME_CONFIG__ ?? {}) : {};
}
